import $ from 'jquery';
import Rellax from 'rellax';
import AOS from 'aos';
import 'slick-carousel';
import 'is-in-viewport';
import reframe from 'reframe.js';
import 'tablesorter';
import specBuilderConfig from './specBuilderConfig';
import fancybox from '@fancyapps/fancybox';

$(document).ready(() => {

    /* Menu */
    $('header .hamburger').click(() => {
        if ($('body').hasClass('open')) {
            $('body').removeClass('open');
        } else {
            $('body').addClass('open');
        }
    });
    $('header .primary li .toggle').click(function() {
        if ($(this).closest('li').hasClass('active-subnav')) {
            $(this).closest('li').removeClass('active-subnav');
        } else {
            $(this).closest('li').addClass('active-subnav');
            $(this).closest('li').siblings().removeClass('active-subnav');
        }

        return false;
    });

    /* Header Scroll */
    let didScroll,
        lastScrollTop = 0;
    const delta = 5;
    const navbarHeight = 150;

    $(window).scroll(event => {
        didScroll = true;
    });
    setInterval(() => {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    function hasScrolled() {
        const st = $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }
        if (st > lastScrollTop && st > navbarHeight) {
            $('header')
                .removeClass('nav-down')
                .addClass('nav-up');
        } else if (st + $(window).height() < $(document).height()) {
            $('header')
                .removeClass('nav-up')
                .addClass('nav-down');
        }
        if (st <= navbarHeight) {
            $('header')
                .removeClass('nav-up')
                .removeClass('nav-down');
        }
        lastScrollTop = st;
    }

    $(document).on('click', 'table.solid th', function(e) {
        let table = $(this).parents('table').eq(0),
            rows = table.find('tr:gt(0)').toArray().sort(comparer($(this).index()));

        this.asc = !this.asc;
        $(this).find('.sort').remove();
        $(this).siblings().find('.sort').remove();
        if (!this.asc) {
            rows = rows.reverse();
            $(this).append('<span class="sort"><i class="fas fa-caret-up"></i></span>');
        } else {
            $(this).append('<span class="sort"><i class="fas fa-caret-down"></i></span>');
        }
        for (let i = 0; i < rows.length; i++) {
            table.append(rows[i]);
        }
    });

    /* Table sort helper functions */
    function comparer(index) {
        return function(a, b) {
            let valA = getCellValue(a, index),
                valB = getCellValue(b, index);

            return $.isNumeric(convert(valA)) && $.isNumeric(convert(valB))
                ? convert(valA) - convert(valB)
                : valA.toString().localeCompare(valB);
        };
    }

    function convert(_x) {
        if (_x.includes('"') && $.isNumeric(_x.slice(0, -1))) {
            _x = _x.slice(0, -1);
        }
        if (_x.includes(' ') && _x.includes('/')) {
            let parts = _x.split(' '),
                decParts = parts[1].split('/');

            return parseInt(parts[0], 10) + parseInt(decParts[0], 10) / parseInt(decParts[1], 10);
        } else if (_x.includes('/') && !_x.includes(' ')) {
            let parts = _x.split('/');

            return parseInt(parts[0]) / parseInt(parts[1]);
        }

        return parseFloat(_x);

    }

    function getCellValue(row, index) {
        return $(row).children('td').eq(index).text();
    }
    /* END Table sort helper functions */

    /* Slider */
    $('.slider').slick({
        appendDots: '.dots-container',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        draggable: true,
        fade: true,
        infinite: false,
        pauseOnHover: true,
        slidesToShow: 1
    });
    $('.gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        infinite: false,
        fade: true,
        asNavFor: '.gallery-nav'
    });
    $('.gallery-nav').slick({
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        asNavFor: '.gallery',
        dots: true,
        infinite: false,
        focusOnSelect: true
    });

    function workSliderSettings() {
        return {
            arrows: false,
            autoplay: false,
            dots: true,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1
        };
    }
    $('.work-slider').each(function() {
        $(this).slick({
            arrows: false,
            autoplay: false,
            dots: true,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1
        });
    });
    $('.carousel').each(function(i, e) {
        $(this).slick({
            arrows: true,
            autoplay: false,
            centerMode: true,
            dots: false,
            draggable: true,
            fade: false,
            infinite: true,
            initialSlide: 2,
            nextArrow: '<button class="next"><i class="fas fa-chevron-right"></i></button>',
            prevArrow: '<button class="prev"><i class="fas fa-chevron-left"></i></button>',
            responsive: [
                {
                    breakpoint: 1259,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 959,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ],
            slidesToShow: 4
        });
    });
    $('[data-fancybox]').fancybox({
        afterShow: function(instance, slide) {
            $(this.src).find('.work-slider').slick('unslick');
            $(this.src).find('.work-slider').each(function() {
                $(this).slick({
                    arrows: false,
                    autoplay: false,
                    dots: true,
                    draggable: false,
                    infinite: false,
                    slidesToShow: 1
                });
            });
        }
    });

    reframe('iframe');

    $('body :not(script)').contents().filter(function() {
        return this.nodeType === 3;
    }).replaceWith(function() {
        return this.nodeValue.replace(/[â„¢Â®Â©]/g, '<sup>$&</sup>');
    });

    /* Items Count */
    function itemsCount() {
        const count = $('.loaded-items .item').length;

        $('.item-count').html(count);
    }
    itemsCount();

    /* Form Subjects */
    const subjectSelector = 'input[name="subject"]';
    const firstNameSelector = 'input[name="fromName"]';
    const lastNameSelector = 'input[name="message[LastName]"]';
    const contactFormSelector = '.js-contact-form';
    const dealerFormSelector = '.js-find-a-dealer-form';
    const fieldSelector = `${contactFormSelector} ${firstNameSelector},
    ${contactFormSelector} ${lastNameSelector},
    ${dealerFormSelector} ${firstNameSelector},
    ${dealerFormSelector} ${lastNameSelector}`;

    $(fieldSelector).blur(e => {
        const $field = $(e.target);
        const $form = $field.closest('form');
        const subjectPrefix = $form.attr('data-subject');
        const $subjectInput = $form.find(subjectSelector);
        const firstName = $form.find(firstNameSelector).val();
        const lastName = $form.find(lastNameSelector).val();
        let subject = `${subjectPrefix} from`;

        // Add name to the subject prefix
        if (firstName) {
            subject = `${subject} ${firstName}`;
        }
        if (lastName) {
            subject = `${subject} ${lastName}`;
        }

        // Update the subject input so this will get sent via email
        $subjectInput.val(subject);
    });

    /* Ajax */
    $(document).on('click', 'a.load-more', function(e) {
        const href = $(this).attr('href');
        const button = $(this);

        $(button).text('Loading');
        $.ajax({
            url: href,
            success(data) {
                $(button).remove();
                $('.loaded-items').append($(data).find('.loaded-items').html());
                $('.loaded-items-alt').append($(data).find('.loaded-items-alt').html());
                $('.load-buttons').append($(data).find('.load-buttons').html());
                itemsCount();
            }
        });
        e.preventDefault();

        return false;
    });

    $(document).on('change', 'select[name=filter]', function(e) {
        const href = $(this).val();

        $('.loaded-items').html('');
        $('.load-buttons').html('<span class="loading"></span>');
        $.ajax({
            url: href,
            success(data) {
                $('.loaded-items').html($(data).find('.loaded-items').html());
                $('.loaded-items-alt').html($(data).find('.loaded-items-alt').html());
                $('.load-buttons').html('');
                $('.load-buttons').html($(data).find('.load-buttons').html());
                $('.item-total').html($(data).find('.item-total').html());
                $('.filter').html($(data).find('.filter').html());
                $('form.entry-search').attr('action', $(data).find('form.entry-search').attr('action'));
                itemsCount();
                history.pushState({}, '', href);
            }
        });
        e.preventDefault();

        return false;
    });

    $(document).on('click', '.sort-column', function(e) {
        const href = $(this).val();

        $('.loaded-items').html('');
        $('.load-buttons').html('<span class="loading"></span>');
        $.ajax({
            url: href,
            success(data) {
                $('.loaded-items').html($(data).find('.loaded-items').html());
                $('.loaded-items-alt').html($(data).find('.loaded-items-alt').html());
                $('.load-buttons').html('');
                $('.load-buttons').html($(data).find('.load-buttons').html());
                $('.item-total').html($(data).find('.item-total').html());
                $('.filter').html($(data).find('.filter').html());
                $('form.entry-search').attr('action', $(data).find('form.entry-search').attr('action'));
                itemsCount();
                history.pushState({}, '', href);
            }
        });
        e.preventDefault();

        return false;
    });

    /* Spec Builder */
    function hideInput($fieldset) {
        $fieldset.addClass('hidden');
        $fieldset.find('select, input').prop('required', false).val([]);
    }
    function showInput($fieldset) {
        $fieldset.removeClass('hidden');
        $fieldset.find('select, input').prop('required', true);
    }
    const $specs = $('#specs');
    const thicknessName = 'message[Thickness]';
    const $thickness = $(`[name="${thicknessName}"]`);
    const $thicknessFieldset = $thickness.closest('fieldset');
    const $dynamicFields = $specs.find('fieldset.dynamic');
    const hideFields = function() {
        hideInput($thicknessFieldset);
        $dynamicFields.each(function() {
            hideInput($(this));
        });
    };

    function specs(clearAllFields, clearDynamicFields) {
        const selectedType = $specs.find('select.product-type').val();

        if (!selectedType) {
            // If no type is selected or there aren't dynamic fields, hide all other
            // fields.
            hideFields();

            return;
        }

        const selectedThickness = $thickness.val();
        const typeData = specBuilderConfig[selectedType][thicknessName];
        const thicknesses = Object.keys(typeData);

        // Set thickness options
        $thickness.find('option').each(function() {
            const $option = $(this);
            const value = $option.val();

            if (!value || thicknesses.includes(value)) {
                $option.removeAttr('disabled').show();
            } else {
                $option.attr('disabled', 'disabled').hide();
            }
        });
        if (clearAllFields) {
            hideFields();
            showInput($thicknessFieldset);

            return;
        }
        showInput($thicknessFieldset);

        // Set dynamic field options
        if (!selectedThickness) {
            // If no thickness is selected, hide all other dynamic fields and return.
            $dynamicFields.each(function() {
                hideInput($(this));
            });

            return;
        }

        const thicknessData = typeData[selectedThickness];

        $dynamicFields.each(function() {
            const $fieldset = $(this);

            if (clearDynamicFields) {
                $fieldset.find('select, input').prop('required', false).val([]);
            }
            $fieldset.find('select').each(function() {
                const $select = $(this);
                const selectName = $select.prop('name');
                const selectOptions = thicknessData[selectName];

                if (selectName in thicknessData) {
                    $select.find('option').each(function() {
                        const $option = $(this);
                        const value = $option.val();

                        if (!value || selectOptions.includes(value)) {
                            $option.removeAttr('disabled').show();
                        } else {
                            $option.attr('disabled', 'disabled').hide();
                        }
                    });
                    showInput($fieldset);
                } else {
                    hideInput($fieldset);
                }
            });
            if (selectedType != 'Autem') {
                $fieldset.find('input').each(() => {
                    showInput($fieldset);
                });
            } else {
                $fieldset.find('input').each(() => {
                    hideInput($fieldset);
                });
            }
        });
    }
    $specs.find('select.product-type').change(() => {
        specs(true);
    });
    $specs.find(`select[name="${thicknessName}"]`).change(() => {
        specs(false, true);
    });

    $('#specs fieldset select, #specs fieldset input').change(() => {
        let subject = [];

        $('#specs fieldset select').each(function() {
            subject.push($(this).val());
            $('#specs input.subject').val(subject);
        });
        $('#specs fieldset input:checked').each(function() {
            subject.push($(this).val());
            $('#specs input.subject').val(subject);
        });
    });

    /* Parallax */
    if ($('.rellax').length) {
        const rellax = new Rellax('.rellax', {
            center: true
        });
    }
    function parallax() {
        $('.parallax').each(function() {
            const scroll = $(document).scrollTop() - $(this).offset().top;

            $(this).css({
                'background-position': `center ${0.2 * scroll}px`
            });
        });
    }
    parallax();
    $(window).scroll(() => {
        parallax();
    });

    /* Page animations */
    AOS.init({
        easing: 'ease-out-back',
        duration: 1000
    });
});

/*
    By Osvaldas Valutis, www.osvaldas.info
    Available for use under the MIT License
*/

'use strict';

(function(document, window, index) {
    let inputs = document.querySelectorAll('.file');

    Array.prototype.forEach.call(inputs, input => {
        let label = input.nextElementSibling,
            labelVal = label.innerHTML;

        input.addEventListener('change', function(e) {
            let fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else {
                fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
                label.querySelector('span').innerHTML = fileName;
            } else {
                label.innerHTML = labelVal;
            }
        });

        // Firefox bug fix
        input.addEventListener('focus', () => {
            input.classList.add('has-focus');
        });
        input.addEventListener('blur', () => {
            input.classList.remove('has-focus');
        });
    });
}(document, window, 0));
